import React from 'react'
import ReactDOM from 'react-dom/client'
import './lib/i18n'
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />,
)
